/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_ListInputs */

const en_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable List`)
};

const fr_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer la liste`)
};

const de_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste aktivieren`)
};

const it_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita elenco`)
};

const ru_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить список`)
};

const es_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de habilitación`)
};

const zh_cn2_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用列表`)
};

const ja_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストを有効にする`)
};

const hi_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची सक्षम करें`)
};

const pt_pt2_enable_list = /** @type {(inputs: Enable_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar lista`)
};

/**
* | output |
* | --- |
* | "Enable List" |
*
* @param {Enable_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_list = /** @type {((inputs?: Enable_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enable_list(inputs)
	if (locale === "de") return de_enable_list(inputs)
	if (locale === "it") return it_enable_list(inputs)
	if (locale === "ru") return ru_enable_list(inputs)
	if (locale === "es") return es_enable_list(inputs)
	if (locale === "zh-CN") return zh_cn2_enable_list(inputs)
	if (locale === "ja") return ja_enable_list(inputs)
	if (locale === "hi") return hi_enable_list(inputs)
	if (locale === "pt-PT") return pt_pt2_enable_list(inputs)
	return en_enable_list(inputs)
});